import { render, staticRenderFns } from "./checkmark-thick.vue?vue&type=template&id=3fbbfb5f&scoped=true&"
var script = {}
import style0 from "./checkmark-thick.vue?vue&type=style&index=0&id=3fbbfb5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbfb5f",
  null
  
)

export default component.exports